module.exports = __webpack_public_path__ + "img/2_1-commerciale-mercato-2.e5b72486.png";